import React, { useContext, useState } from "react";
import { AutomationSection } from "../../context/AutomationContext";
import { ModalComp, Time, MapComp } from "../";
import { Scenario } from "../Scenarios/Scenario";

const AutomationIfPage = () => {
  const { AutomationShowHideFunc } = useContext(AutomationSection);
  const [openTimeModal, setOpenTimeModal] = useState(false);
  const toggleTime = () => setOpenTimeModal(!openTimeModal);
  const [openMapgModal, setOpenMapgModal] = useState(false);
  const toggleMap = () => setOpenMapgModal(!openMapgModal);
  const [openEditModal, setOpenEditModal] = useState(false);
  const toggleEdit = () => setOpenEditModal(!openEditModal);
  const [openScenarioModal, setOpenScenarioModal] = useState(false);
  const toggleScenario = () => setOpenScenarioModal(!openScenarioModal);

  return (
    <>
      <ModalComp
        modal={openTimeModal}
        toggle={toggleTime}
        component={<Time />}
      />
      <ModalComp
        modal={openMapgModal}
        toggle={toggleMap}
        component={<MapComp />}
      />
      <ModalComp
        modal={openScenarioModal}
        toggle={toggleScenario}
        component={<Scenario />}
        dark={true}
      />
      <div className="px-3">
        <h5 className="text-right mb-4">اگر</h5>
        <div className="addScenarioCard mb-3 bg-white d-flex justify-content-between align-items-center p-3">
          <div className="text-right">
            <p className="mb-1 fn">زمانبندی</p>
            <p className="m-0 fn12 muted">مثال: ساعت 05:50 صبح</p>
          </div>
          <div
            className="addScenarioIcon d-flex justify-content-center align-items-center rounded-circle text-white cursor"
            onClick={toggleTime}
          >
            +
          </div>
        </div>
        <div className="addScenarioCard mb-3 bg-white d-flex justify-content-between align-items-center p-3">
          <div className="text-right">
            <p className="mb-1 fn">وضعیت</p>
            <p className="m-0 fn12 muted">مثال: روشن شدن چراغ</p>
          </div>
          <div
            className="addScenarioIcon d-flex justify-content-center align-items-center rounded-circle text-white cursor"
            onClick={toggleEdit}
          >
            +
          </div>
        </div>
        <div className="addScenarioCard mb-3 bg-white d-flex justify-content-between align-items-center p-3">
          <div className="text-right">
            <p className="mb-1 fn">موقعیت مکانی</p>
            <p className="m-0 fn12 muted">مثال: در محدوده خانه</p>
          </div>
          <div
            className="addScenarioIcon d-flex justify-content-center align-items-center rounded-circle text-white cursor"
            onClick={toggleMap}
          >
            +
          </div>
        </div>
        <div className="addScenarioCard mb-3 bg-white d-flex justify-content-between align-items-center p-3">
          <div className="text-right">
            <p className="mb-1 fn">براساس سناریو</p>
            <p className="m-0 fn12 muted">مثال: فعال شدن سناریو خاص</p>
          </div>
          <div
            className="addScenarioIcon d-flex justify-content-center align-items-center rounded-circle text-white cursor"
            onClick={toggleScenario}
          >
            +
          </div>
        </div>
        <div className="addScenarioCard mb-3 bg-white d-flex justify-content-between align-items-center p-3">
          <div className="text-right">
            <p className="mb-1 fn">راهنمای صوتی</p>
            <p className="m-0 fn12 muted">مثال: چراغ را روشن کن !</p>
          </div>
          <div className="addScenarioIcon d-flex justify-content-center align-items-center rounded-circle text-white cursor">
            +
          </div>
        </div>
        <div className="d-flex flex-wrap justify-content-center mt-5">
          <div
            className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
            onClick={() => AutomationShowHideFunc("elsePage")}
          >
            <span className="profileAddUser bg-white d-block cursor icon-right"></span>
            <small className="fn12 mt-1">بعدی</small>
          </div>
          <div
            className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
            onClick={() => AutomationShowHideFunc("firstPage")}
          >
            <span className="profileAddUser bg-white d-block icon-left-1 cursor"></span>
            <small className="fn12 mt-1">بازگشت</small>
          </div>
        </div>
      </div>
    </>
  );
};

export { AutomationIfPage };
